<template>
    <div class="overlay" v-show="display">
        <div>
            <div class="modal_box wd720">
                <div class="modal_header_unit">
                    <div class="modal_header_box">
                        <p class="modal_header_tit">警告</p>
                    </div>
                </div>
                <div class="modal_content_tex">
                    <p class="text_white_space_pre_wrap">プレビューのため操作できません。</p>
                </div>
                <div class="btn_submit">
                    <a href="#" role="button" @click.stop.prevent="close()">了解</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlertDialog",
        props: {
            display: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
        }
    }
</script>